<template>
  <div class="nav-text mt-1 pt-2">
    Usted se encuentra aqu&iacute;:
    <span v-for="(item, index) in page.routes" :key="index">
      <a
        :class="{ 'nav-text-current': index === page.routes.length - 1 }"
        class="nav-text-link"
      >
        {{ item }}
        <span v-if="!(index === page.routes.length - 1)">/</span>
      </a>
    </span>
  </div>
</template>

<style scoped>
/*text for navigation*/
.nav-text {
  text-align: left;
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  margin-bottom: 1rem;
}

.nav-text-link {
  color: black;
  font-weight: 400;
  text-decoration: none;
}
.nav-text-link:hover {
  color: black;
  text-decoration: none;
  font-weight: 800;
}
.nav-text-current {
  color: black;
  font-weight: 700;
  text-decoration: none;
}
.nav-text-current:hover {
  color: black;
  text-decoration: none;
  font-weight: 800;
}
</style>

<script>
export default {
  meta: {
    description:
      'Componente BreadCrumb, estable la ruta del posicionamiento en la página.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    page: {
      type: Object,
      default: () => {},
      meta: {
        description: 'Ruta entre las páginas',
        example: 'Objeto Requerido',
      },
    },
  },
};
</script>
